import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from "@angular/material/dialog";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {Store} from "@ngxs/store";
import {ProductApiStatusState, SetEdited} from "../../product/state";
import {Observable, timer} from "rxjs";
import {DownloadService} from "../../../services";
import {Version} from "../../../services/api";
import {HttpResponse} from "@angular/common/http";
import {EditDialogData} from "../../../interfaces";
import {SubscriptionHandlerComponent} from "../subscription-handler/subscription-handler.component";

@Component({
    selector: 'app-edit-file-dialog',
    imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, MatInputModule, MatCardModule, FormsModule],
    templateUrl: './edit-file-dialog.component.html',
    styleUrl: './edit-file-dialog.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
// Component to edit a file-value
export class EditFileDialogComponent extends SubscriptionHandlerComponent {
    editedValue$: Observable<boolean | null> = this.store.select(ProductApiStatusState.editedValue);

    // Edit button pressed flag
    editPressed: boolean = false;

    fileName: string = "";
    fileSize: number;

    // not used
    requiredFileType: string;

    version: Version;

    file: File;

    constructor(@Inject(MAT_DIALOG_DATA) public data: EditDialogData,
                private store: Store,
                private dialogRef: MatDialogRef<EditFileDialogComponent>,
                private downloadService: DownloadService) {
        super();
        this.fileName = data.value;
    }

    // Upload a file event
    uploadFile(event: any) {
        this.file = event.target.files[0];

        if (this.file) {
            this.fileSize = this.file.size;
            this.fileName = this.file.name;
        }
    }

    // Edit the file and close the dialog
    async editValue() {
        this.editPressed = true;
        let response = await this.downloadService.uploadArtefact(this.file, this.version.id)

        this.subscribeTo(response, result => {
            this.store.dispatch(new SetEdited(result.status === 200))
        })

        // Close the dialog 2 seconds after editing
        this.subscribeTo(this.editedValue$, x => {
            if (x) {
                timer(2000).subscribe(() => this.dialogRef.close(true))
            }
        })
    }

    // Remove the file and close the dialog
    deleteValue() {
        if (this.version.artefact === "") {
            this.fileName = "";
        } else {
            this.editPressed = true;
            this.subscribeTo(this.downloadService.deleteArtefact(this.version.id!, "response"), (response: HttpResponse<any>) => {
                this.store.dispatch(new SetEdited(response.status === 200));
            });

            // Close the dialog 2 seconds after editing
            this.subscribeTo(this.editedValue$, x => {
                if (x) {
                    this.fileName = "";
                    timer(2000).subscribe(() => this.dialogRef.close(true));
                }
            });
        }
    }
}
